import React, { Component } from 'react';
// import { Link } from "react-router-dom";
import "../css/Home.css";

// import header from '../../images/Header.JPG';

class Home extends Component {
    render() {
        return (
            <div className="container-fluid">
                <div className="landing"></div>
            </div>
        );
    }
}

export default Home;
